import * as React from "react";
import {Alert, Button, Row, Col, Card} from "react-bootstrap";
import SideBar from "../../../components/SideBar/Sidebar";
import { Link, withRouter, RouteComponentProps} from "react-router-dom";
import { connect } from "react-redux";
import withRequestState from "../../../components/WithRequestState";
import { RequestStateProps } from "../../../interfaces/RequestState";
import { State } from "../../../interfaces/State";
import {Equipment} from "../../../interfaces/Equipment";
import {Report} from "../../../interfaces/Report";
import {getEquipment} from "../../../redux/equipment/actions";
import Site from "../../../interfaces/Site";
import QRCode from "qrcode.react";
import { Project } from "../../../interfaces/Project";
import {Tabs, Tab} from "../../../components/tabs";
import "./index.scss";
import * as moment from "moment";
import { getProject } from "../../../redux/projects/selectors";
import { getProjects } from "../../../redux/projects/action";
import Zone from "./zone";


interface IProps {
    equipment: Equipment[];
    getEquipment: () => void;
    getProjects: () => void;
    reports: Report[];
    projects: Project[];  
    project: Project;  
}

interface IState {
    calender: string[];
}

class ProjectPage extends React.Component<IProps & RequestStateProps & RouteComponentProps, IState> {

    constructor(props){
        super(props);
        this.state = {
            calender: this.buildCalender()
        }
    }

    componentDidMount(){
        if (this.props.equipment.length == 0) {
            this.props.getEquipment();
        }

        if (this.props.project == null){
            this.props.getProjects();
        }
    }

    getReports() {
        return this.props.equipment
            .map(equipemnt => equipemnt.preStartForms)
            .reduce((a, b) => a.concat(b), []);
    }

    buildCalender() : string[] {
        const month = moment().startOf("month");
        const elements = [];
        for (let i = 0; i < moment().startOf("month").daysInMonth(); i++){
            elements.push(month.format('DD-ddd'));
            month.add(1, "day");
        }
        return elements;
    }

    addNewSite(){

    }

    render(){
        const {match: {params}} = this.props;

        if (this.props.project == null){
            return (
                <p>Loading</p>
            )
        }

        return (
            <div className="main-page project-page pt-3" id="project-page">

                {
                    this.props.project.sites.length == 0 ? 
                        <div>
                            <p>Project has no zones</p>
                        </div> : 
                        <Tabs add={true} onClick={() => this.addNewSite()} addTitle="Add new zone" addTabClassName="add-zone">
                            {
                                this.props.project.sites.map(site => (
                                    <Tab title={site.name} subTitle="Active" id={1} className="site">
                                        <Zone project={this.props.project} />
                                    </Tab>
                                ))
                            }
                        </Tabs>

                }

               

                
            </div>
        )
    }

}


export default withRouter(connect((state : State, params) => ({
    equipment: state.equipment,
    reports: state.reports,
    projects: state.projects,
    project: getProject(state, params)
}), ({
    getEquipment,
    getProjects
}))(withRequestState(ProjectPage, [])));